<template>
  <div
    v-if="taskShow"
    style="width:100%;height:100%;position:absolute;top:0;left:0"
    @click.stop="doHide"
  >
    <div style="position:relative;width:100%;height:100%" class="flexCenter">
      <div
        class="studentContainer"
        style="background:rgba(0,0,0,0)"
        @click.stop=""
      >
        <div
          style="width:100%;height:100%;background:#ffffff;border-radius:2rem;"
        >
          <div
            style="height:4rem;width:100%;text-align:center;line-height:4rem;position:relative;background:#CFEEFF;border-radius: 2rem 2rem 0px 0px;font-size: 2rem;color: #0F85DB;"
          >
            {{ nickname }}的练习
            <img
              src="../assets/icon_task_close.png"
              style="width: 3rem;height: 3rem;position: absolute;right: 1rem;top: 0.5rem;cursor: pointer"
              @click.stop="doHide"
            />
          </div>
          <div
            v-if="students.length > 0 && loaded"
            style="height:calc( 100% - 4rem );border-radius:2rem;overflow:scroll"
            ref="studentTaskScroll"
            class="studentTaskScroll"
          >
            <div
              style="padding:1rem;display: grid;grid-template-columns: 1fr 1fr 1fr;grid-column-gap: 1rem;grid-row-gap: 1rem;"
              ref="studentTaskScrollContainer"
            >
              <div
                v-for="(item, index) in students"
                :key="index"
                style="position: relative; width:100%;border-radius:1rem;cursor: pointer;overflow: hidden"
                @click="picMarkShow(item.pic, index)"
              >
                <img :src="item.pic" style="width:100%" />
                <img
                  v-if="item.recommended == '1'"
                  src="../assets/recommended.png"
                  style="width: 8.2rem;height: 5.8rem;position: absolute;top:-1rem;right: -1rem"
                />
              </div>
            </div>
          </div>
          <div
            v-if="students.length <= 0 && loaded"
            style="height:calc( 100% - 4rem );border-radius:2rem;overflow:hidden"
            class="flexCenter"
          >
            <div
              style="width:32rem;height:31rem;font-size:1.4rem;color:#0F85DB;position:relative;overflow:hidden;margin-top:11rem"
            >
              <img src="../assets/task_nodata.png" style="width:100%;" />
              <div
                style="position:absolute;width:100%;height:100%;top:0;left:0"
                class="flexCenter"
              >
                暂无练习
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <pic-mark
      ref="pic-mark"
      @prev-page="prevPage"
      @next-page="nextPage"
    ></pic-mark>
  </div>
</template>

<script>
import PicMark from './PicMark.vue'
export default {
  name: 'StudentTask',
  components: {
    PicMark,
  },
  data() {
    return {
      nickname: '',
      taskShow: false,
      students: [],
      loaded: false,
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    doHide() {
      this.taskShow = false
    },
    prevPage(idx) {
      if (idx == 0) return
      let newIdx = idx - 1
      this.picMarkShow(this.students[newIdx].pic, newIdx)
    },
    nextPage(idx) {
      if (idx == this.students.length - 1) return
      let newIdx = idx + 1
      this.picMarkShow(this.students[newIdx].pic, newIdx)
    },
    show(class_id, student_id, nickname) {
      this.taskShow = true
      this.nickname = nickname
      this.initData(class_id, student_id)
    },
    initData(class_id, student_id) {
      this.$http
        .post('/api/v2/handwriting/BigScreen/get_class_student_works_list', {
          class_id: class_id,
          student_id: student_id,
        })
        .then((res) => {
          if (res.code == '200') {
            let list = res.data
            this.students = list || []
            this.loaded = true
            if (this.students.length > 0) {
              this.$nextTick(() => {
                this.$refs['studentTaskScroll'].scrollTo(0, 0)
              })
            }
          }
        })
    },
    picMarkShow(pic, index) {
      this.$refs['pic-mark'].show(pic, index)
    },
  },
}
</script>
<style scoped>
.studentTaskScroll::-webkit-scrollbar {
  display: none;
}
.loginContainer {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999;
  width: 100vw;
  height: 100vh;
  background: url('../assets/class_bg.png') no-repeat;
  background-size: 100% 100%;
}

.studentContainer {
  width: 80rem;
  height: calc(100vh - 10.4rem);
  padding: 0.5rem;
  margin: 0 auto;
  background: linear-gradient(
    to bottom right,
    rgba(255, 255, 255, 0.7) 0%,
    rgba(255, 255, 255, 0) 50%,
    rgba(255, 255, 255, 0.7) 100%
  );
  border-radius: 2rem;
}

.sendSmsBtn {
  cursor: pointer;
  width: 6.8rem;
  height: 2.4rem;
  line-height: 2.4rem;
  text-align: center;
  font-size: 1.4rem;
  border-radius: 1.2rem;
  color: #ffffff;
  background: linear-gradient(to right, #ffa143, #ffc11d);
}

.sendSmsBtn:hover {
  background: linear-gradient(to right, #f38b22, #f38b22);
}

.loginBtn {
  cursor: pointer;
  width: 6.8rem;
  height: 2.4rem;
  line-height: 2.4rem;
  text-align: center;
  font-size: 1.4rem;
  border-radius: 1.2rem;
  color: #ffffff;
  background: #2a9bff;
}

.loginBtn:hover {
  background: #158ffa;
}

.classContainer {
  width: 200%;
  position: absolute;
  top: 0;
  left: -50%;
  background: red;
  overflow: hidden;
  border-radius: 0 0 50% 50%;
  background: linear-gradient(
    0deg,
    rgba(15, 133, 219, 0.25) 0%,
    rgba(255, 255, 255, 0) 30%,
    rgba(255, 255, 255, 0) 100%
  );
}
</style>
